import { IComponentOptions, IController } from 'angular';
import { IAdditionalInfoModalData } from './additional-info-modal-data.interface';
import './additional-info-modal.component.scss';

class AdditionalInfoModalCtrl implements IController {
  data: IAdditionalInfoModalData;
  onClose: ( data: { result: any } ) => void;
  defaultTitle = 'Additional info';
  closeBtnCheck: boolean = true;

  constructor() {
  }

  $onInit() {
    if (this.data.disableCloseBtn) {
      this.closeBtnCheck = false;
    }
  }

  closeModal( result: boolean ) {
    this.onClose({ result });
  }

}

export const AdditionalInfoModalComponent: IComponentOptions = {
  controller: AdditionalInfoModalCtrl,
  template: require('./additional-info-modal.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/components/modals/additional-info-modal/additional-info-modal.component.ts